//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/Builder.js";
import "../no/TaggedObjectList.js";
import "../no/ObjectList.js";
let d=[[[1,"CriteriaList",0,"TaggedObjectList",0],[0,"ModelViewName",1,0],[0,"PmiType",1,0],[0,"SearchScope",1,0]],[[[],"ExecuteSearch",{},0,0],[[],"SaveAsModelView",{},0,0],[["nResults"],"GetResults",{R_:{results:"NXObject[]"}},0,0],[["searchType"],"CreateCriteriaObject",{R_:{criteriaObject:"NXObject"}},1,0],[["criteriaObject"],"DeleteCriteriaObject",{},1,0]],[]];
SPLM.Annotations.SearchModelViewBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.SearchModelViewBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.SearchModelViewBuilder.PmiTypes = Object.freeze({
    "Dimension" : "Dimension", "FeatureControlFrame" : "FeatureControlFrame", "DatumFeatureSymbol" : "DatumFeatureSymbol", "DatumTarget" : "DatumTarget", "SurfaceFinish" : "SurfaceFinish", "Note" : "Note"});

SPLM.Annotations.SearchModelViewBuilder.ValueComparisionOptions = Object.freeze({
    "Less" : "Less", "LessEqual" : "LessEqual", "Equal" : "Equal", "MoreEqual" : "MoreEqual", "More" : "More"});

SPLM.Annotations.SearchModelViewBuilder.TextComparisionOptions = Object.freeze({
    "Equals" : "Equals", "Contains" : "Contains"});

SPLM.Annotations.SearchModelViewBuilder.SearchScopeOptions = Object.freeze({
    "WorkPart" : "WorkPart", "WorkPartAndComponents" : "WorkPartAndComponents"});

export default SPLM;